<template>
  <div>
    <el-form
      ref="dataDetailRef"
      size="small"
      :model="dataDetail"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <!--假期名称-->
          <el-form-item
            :label="$t('home.HolidayName')"
            prop="name"
            :rules="{
              required: true,
              message: this.$t('CenterForSorting.notNull'),
              trigger: ['blur', 'change']
            }"
          >
            <el-input v-model="dataDetail.name" :placeholder="$t('CenterForSorting.pleaseInput')" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--选择日期-->
          <el-form-item
            :label="$t('operationCenter.SelectDate')"
            prop="date"
            :rules="{
              required: true,
              message: this.$t('CenterForSorting.notNull'),
              trigger: ['blur', 'change']
            }"
          >
            <!--:picker-options="pickerOptions"-->
            <el-date-picker
              v-model="dataDetail.date"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('GlobalSetObj.startDate')"
              :end-placeholder="$t('GlobalSetObj.endDate')"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--假期类型-->
          <el-form-item
            :label="$t('home.HolidayType')"
            prop="type"
            :rules="{
              required: true,
              message: this.$t('CenterForSorting.notNull'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="dataDetail.type"
              :placeholder="$t('placeOrder.pleaseChoose')"
              style="width: 100%"
              clearable
              @change="changeType(dataDetail.type)"
            >
              <el-option :key="1" :label="$t('home.NationalHoliday')" :value="1" /><!--全国假期-->
              <el-option :key="2" :label="$t('home.LocalHoliday')" :value="2" /><!--地方假期-->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="dataDetail.type === 2" :span="24">
          <!--选择州或城市-->
          <el-form-item
            :label="$t('home.SelectStateCity')"
            prop="targetLocations"
            :rules="{
              required: dataDetail.type === 2,
              message: this.$t('CenterForSorting.notNull'),
              trigger: ['blur', 'change']
            }"
          >
            <el-cascader
              v-model="dataDetail.targetLocations"
              :options="processedStateCityOptions"
              :props="cascaderProps"
              :show-all-levels="false"
              clearable
              filterable
              style="width: 100%"
              @change="handleTargetLocationChange(dataDetail.targetLocations)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--选择客户-->
          <el-form-item
            :label="$t('orderCenterCont.SelectCustomers')"
            prop="targetCustomerIds"
            :rules="{
              required: true,
              message: this.$t('CenterForSorting.notNull'),
              trigger: ['blur', 'change']
            }"
          >
            <el-select
              v-model="dataDetail.targetCustomerIds"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              remote
              multiple
              reserve-keyword
              size="small"
              style="width: 100%"
              @visible-change="getCustomerPageList"
              @change="changeTargetCustomer()"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--选择商户-->
          <el-form-item :label="$t('home.SelectMerchant')" prop="targetMerchantCodes">
            <el-select
              v-model="dataDetail.targetMerchantCodes"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getShanghu"
              clearable
              filterable
              remote
              multiple
              reserve-keyword
              size="small"
              style="width: 100%"
              @visible-change="getShanghuList"
            >
              <el-option
                v-for="item in commercialList"
                :key="item.code"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { apiCustomerPage, apimerchantName } from '@/api/customer';
import { holidayAdd, holidayEdit } from '@/api/newExpressAPI';
export default {
  name: 'AddEditDetail',
  props: {
    // 父组件传递的参数
    dataDetail: {
      type: Object,
      default: () => {
        return {
          name: '',
          date: [],
          type: null,
          targetLocations: [],
          targetCustomerIds: [],
          targetMerchantCodes: []
        };
      }
    },
    stateCityOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectedCustomerList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    merchantList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      customerList: this.selectedCustomerList,
      commercialList: [],
      processedStateCityOptions: [],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          return time.getTime() < today.getTime();
        }
      }
    };
  },
  created() {
    this.getCustomerPage();
    if (this.dataDetail.targetCustomerIds.length > 0) {
      this.commercialList = this.merchantList;
    } else {
      this.commercialList = [];
    }
  },
  watch: {
    stateCityOptions: {
      handler(newVal) {
        this.processedStateCityOptions = this.processStateCityOptions(
          newVal,
          this.dataDetail.targetLocations
        );
      },
      deep: true
    }
  },
  computed: {
    cascaderProps() {
      return {
        multiple: true,
        checkStrictly: true,
        value: 'value',
        label: 'label',
        expandTrigger: 'hover',
        disabled: 'disabled'
      };
    }
  },
  mounted() {
    // 初始化处理选项
    this.processedStateCityOptions = this.processStateCityOptions(
      this.stateCityOptions,
      this.dataDetail.targetLocations
    );
  },
  methods: {
    // 打开客户列表选项
    getCustomerPageList(val) {
      if (val) {
        this.getCustomerPage();
      }
    },
    // 打开商户列表选项
    getShanghuList(val) {
      if (val) {
        this.getShanghu();
      }
    },
    // 假期类型变化
    changeType(type) {
      if (type === 1) {
        this.dataDetail.targetLocations = [];
      }
    },
    // 处理级联选项的禁用状态
    processStateCityOptions(options, selectedValues) {
      if (!options || !Array.isArray(options)) return options;
      const processedOptions = JSON.parse(JSON.stringify(options));

      // 获取所有已选择的父级节点值
      const selectedParentValues = (selectedValues || [])
        .filter(arr => Array.isArray(arr) && arr.length === 1)
        .map(arr => arr[0]); // 只取第一级作为父级

      // 清除已选的子级（如果其父级已被选中）
      if (selectedValues && Array.isArray(selectedValues)) {
        // 过滤掉父级已选中的子级选项
        this.dataDetail.targetLocations = selectedValues.filter(location => {
          // 保留只有一级的选项（父级）
          if (location.length === 1) return true;
          // 排除父级已选中的子级选项
          return !selectedParentValues.includes(location[0]);
        });
      }
      // 递归处理每个选项
      const processNode = (node) => {
        if (node.children && node.children.length > 0) {
          // 如果当前节点是已选择的父级，则禁用所有子级
          if (selectedParentValues.includes(node.value)) {
            node.children.forEach(child => {
              child.disabled = true;
              if (child.children) {
                processNode(child);
              }
            });
          } else {
            // 否则递归处理子节点
            node.children.forEach(processNode);
          }
        }
      };

      processedOptions.forEach(processNode);
      return processedOptions;
    },

    // 监听目标位置变化
    handleTargetLocationChange(val) {
      // 更新处理后的选项
      this.processedStateCityOptions = this.processStateCityOptions(
        this.stateCityOptions,
        val
      );
    },
    // 获取客户选项
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param, false).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 客户选项变化
    changeTargetCustomer() {
      this.dataDetail.targetMerchantCodes = [];
      if (this.dataDetail.targetCustomerIds.length > 0) {
        this.getShanghu();
      } else {
        this.commercialList = [];
      }
    },
    // 获取商户
    getShanghu(name = '') {
      this.commercialList = [];
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: name,
          customerIds: this.dataDetail.targetCustomerIds
        }
      };
      apimerchantName(param).then((res) => {
        if (res.code === 200) {
          this.commercialList = res.data.records.map(item => {
            return {
              value: item.merchantCode,
              code: item.merchantCode,
              label: `${item.merchantName}(${item.merchantCode})`
            };
          });
        }
      });
    },
    // 保存
    submitSave() {
      this.$refs.dataDetailRef.validate(valid => {
        if (valid) {
          const paramData = {
            name: this.dataDetail.name,
            startDate: '',
            endDate: '',
            type: this.dataDetail.type,
            targetCustomerIds: this.dataDetail.targetCustomerIds,
            targetLocations: [],
            targetMerchantCodes: this.dataDetail.targetMerchantCodes
          };
          if (this.dataDetail.date && this.dataDetail.date.length) {
            paramData.startDate = this.dataDetail.date[0];
            paramData.endDate = this.dataDetail.date[1];
          }
          if (this.dataDetail.targetLocations && this.dataDetail.targetLocations.length > 0) {
            this.dataDetail.targetLocations.map(item => {
              const provinceAndCity = {
                state: item[0],
                city: item.length > 1 ? item[1] : ''
              };
              paramData.targetLocations.push(provinceAndCity);
            });
          }
          console.log(paramData, '===paramData');
          if (this.dataDetail.id) {
            paramData.id = this.dataDetail.id;
            holidayEdit(paramData).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$emit('updateTable');
              }
            });
          } else {
            paramData.id = null;
            holidayAdd(paramData).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.$emit('updateTable');
              }
            });
          }
        }
      });
    }
  }
};
</script>
